import { PaginationItem, UsePaginationItem, usePagination } from '@material-ui/lab'

interface Props {
  page: number
  count: number
  onChange: (next: number) => void
}
type GroupedItems = Record<UsePaginationItem['type'], UsePaginationItem[]>
export function Pagination({ count, page, onChange }: Props) {
  const { items } = usePagination({
    page,
    count,
    showFirstButton: true,
  })
  const grouped = items.reduce<GroupedItems>((acc, item) => {
    if (!acc[item.type]) {
      acc[item.type] = []
    }
    const required =
      item.type !== 'page' ||
      (page === 1 && item.page <= 3) ||
      (page === count && item.page >= count - 2) ||
      (item.page >= page - 1 && item.page <= page + 1)
    if (required) {
      acc[item.type].push(item)
    }
    return acc
  }, {} as GroupedItems)
  if (count > 3) {
    if (page >= 3) {
      grouped['start-ellipsis'] = [
        {
          disabled: false,
          page: 0,
          selected: false,
          type: 'start-ellipsis',
          onClick: () => {
            // noop
          },
        },
      ]
    }
    if (page <= count - 2) {
      grouped['end-ellipsis'] = [
        {
          disabled: false,
          page: 0,
          selected: false,
          type: 'end-ellipsis',
          onClick: () => {
            // noop
          },
        },
      ]
    }
  }
  const renderItem = (prefix: string) =>
    function renderItem(item: UsePaginationItem, index: number) {
      return (
        <PaginationItem {...item} key={`${prefix}-${index}`} onClick={() => onChange(item.page)} />
      )
    }

  return (
    <div className="faq-pagination faq-pagination-design">
      {grouped.first && grouped.first.map(renderItem('first'))}
      {grouped.previous && grouped.previous.map(renderItem('previous'))}
      <div className="faq-pagination-start-ellipsis">
        {grouped['start-ellipsis'] && grouped['start-ellipsis'].map(renderItem('start-ellipsis'))}
      </div>
      <div className="faq-pagination-pages">
        {grouped.page && grouped.page.map(renderItem('page'))}
      </div>
      <div className="faq-pagination-end-ellipsis">
        {grouped['end-ellipsis'] && grouped['end-ellipsis'].map(renderItem('end-ellipsis'))}
      </div>
      {grouped.next && grouped.next.map(renderItem('next'))}
      {grouped.last && grouped.last.map(renderItem('last'))}
    </div>
  )
}
